import { DndContext } from '@dnd-kit/core'

function DragDropContextProvider({ children, ...restProps }) {
  return <DndContext {...restProps}>{children}</DndContext>
}

export default DragDropContextProvider
